export const WHATSAPP_NUMBER = "31684278941"; // Sin + ni espacios para el enlace wa.me
export const WHATSAPP_DISPLAY = "+31 6 8427 8941";
export const WHATSAPP_CATALOG_URL = `https://wa.me/c/${WHATSAPP_NUMBER}`; // Link directo al catálogo WhatsApp Business
export const BRAND = {
  name: "Romero Watches",
  city: "LATAM",
  country: "",
  email: "contacto@romerowatches.com",
  ig: "@romerowatches",
};

export const buildWhatsAppUrl = (message) => {
  const text = encodeURIComponent(
    message ||
      "Hola Romero Watches, me gustaría más información sobre sus relojes."
  );
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
};

// Catálogo: Relojes originales Pagani Design & Specht Söhne
export const COLLECTION = [
  {
    id: "berny-diver-blue",
    name: "Berny Diver Blue",
    series: "Professional Diver · 200m Automatic",
    price: "184",
    description:
      "Diver profesional Berny con esfera azul sunburst, bisel giratorio unidireccional con acentos naranjas, índices y agujas con Super-LumiNova de alta intensidad y brazalete Oyster de acero 316L. Movimiento automático japonés, resistencia al agua 200m: apto para buceo profesional, snorkeling y natación.",
    image: "/watches/berny-diver-blue.png",
  },
  {
    id: "berny-super-lum-tiffany",
    name: "Berny Super Lum Tiffany",
    series: "Professional Diver · Super Lum · 200m",
    price: "212",
    description:
      "Edición Super Lum de Berny con esfera tiffany degradada, luminiscencia extrema en toda la esfera (visibilidad total en la oscuridad), bisel giratorio unidireccional graduado a 60 minutos y brazalete Jubilee de acero. Movimiento automático, corona atornillada con detalle naranja y resistencia 200m — buceo profesional certificado.",
    image: "/watches/berny-super-lum-tiffany.png",
  },
  {
    id: "specht-sohne-gold",
    name: "Specht & Söhne Gold",
    series: "Integrated · Full Gold",
    price: "165",
    description:
      "Elegancia máxima en oro amarillo. Caja pulida con bisel cannelé, esfera champagne sunburst, índices luminosos dorados, movimiento automático japonés y brazalete integrado H-link en oro macizo. Sofisticación pura en cada detalle.",
    image: "/watches/specht-sohne-gold.png",
  },
  {
    id: "pagani-green-chrono",
    name: "Pagani Design Green",
    series: "Vintage Chronograph · Green Dial",
    price: "137",
    description:
      "Cronógrafo elegante con esfera verde bosque sunburst, subdiales plateados con acabado guilloché, bisel cannelé de acero y brazalete Oyster pulido. Movimiento cuarzo VK64 de precisión y estética vintage sofisticada.",
    image: "/watches/pagani-green-chrono.png",
  },
  {
    id: "addiesdive-2504",
    name: "AddiesDive 2504",
    series: "Diver Automatic · 200m",
    price: "199",
    description:
      "Diver automático AddiesDive con esfera negra, escala 24h interior, índices luminosos, bisel giratorio unidireccional con marcaje blanco y brazalete Oyster de acero. Movimiento automático Miyota 21 jewels japonés, resistencia al agua 200m, apto para buceo profesional.",
    image: "/watches/addiesdive-2504.png",
  },
  {
    id: "wishdoit-red-diver",
    name: "Wishdoit Red Honeycomb",
    series: "Diver Automatic · Red Dial",
    price: "205",
    description:
      "Diver automático con esfera roja de textura honeycomb hexagonal única. Bisel rojo giratorio unidireccional, movimiento automático japonés, resistencia al agua 150m y brazalete Jubilee de cinco eslabones. Un statement piece de coleccionista.",
    image: "/watches/wishdoit-red-diver.png",
  },
  {
    id: "pagani-yellow-chrono",
    name: "Pagani Design Yellow",
    series: "Racing Chronograph · Yellow Dial",
    price: "156",
    description:
      "Cronógrafo de acero inoxidable con esfera amarilla vibrante, subdiales negros contrastados y bisel taquimétrico. Movimiento cuarzo VK64 de alta precisión, cristal mineral endurecido y brazalete Oyster macizo. Un statement piece que se lleva las miradas.",
    image: "/watches/pagani-yellow-chrono.png",
  },
  {
    id: "specht-sohne-5711",
    name: "Specht & Söhne 5711",
    series: "Nautilus · Rose Gold Chocolate",
    price: "163",
    description:
      "Modelo insignia de Specht & Söhne. Caja porthole octogonal en oro rosa con esfera chocolate y relieve horizontal característico, movimiento automático japonés, indicador de fecha y correa de piel de aligátor marrón. Elegancia pura para muñeca refinada.",
    image: "/watches/specht-sohne-5711.png",
  },
  {
    id: "specht-sohne-monaco",
    name: "Specht & Söhne Monaco",
    series: "Racing Chronograph · Square Case",
    price: "168",
    description:
      "Cronógrafo cuadrado inconfundible con esfera azul sunburst, subdiales cuadrados blancos, corona a la izquierda (detalle Monaco) y correa perforada racing con costuras rojas. Movimiento automático japonés y cristal de zafiro.",
    image: "/watches/specht-sohne-monaco.png",
  },
  {
    id: "pagani-1662",
    name: "Pagani Design PD-1662",
    series: "GMT Explorer · Pepsi",
    price: "171",
    description:
      "GMT automático con esfera negra, manecilla GMT roja para segundo huso horario, bisel bicolor rojo/azul (Pepsi) de cerámica y brazalete Jubilee de acero. Movimiento automático Seiko NH34 GMT auténtico, cristal de zafiro y resistencia al agua 100m.",
    image: "/watches/pagani-1662-pepsi.png",
  },
  {
    id: "pagani-1701",
    name: "Pagani Design PD-1701",
    series: "Moonwatch · Cronógrafo",
    price: "158",
    description:
      "Cronógrafo Moonwatch de Pagani Design. Esfera negra con tres subdiales plateados, bisel taquimétrico, botones cronógrafo y correa NATO negra. Cristal de zafiro y movimiento cuarzo VK64 de precisión.",
    image: "/watches/pagani-1701-moon.png",
  },
  {
    id: "pagani-1667",
    name: "Pagani Design PD-1667",
    series: "GMT Explorer II · Polar",
    price: "162",
    description:
      "Automático GMT con esfera blanca polar, manecilla GMT naranja para segundo huso horario, bisel fijo de acero grabado a 24h y brazalete Oyster. Movimiento Seiko NH34 GMT auténtico. Perfecto para viajeros.",
    image: "/watches/pagani-pd1667.png",
  },
];

export const HERO_IMAGE = "/watches/hero-addiesdive-tiffany.png";

export const CRAFT_IMAGE =
  "https://images.pexels.com/photos/29268628/pexels-photo-29268628.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720";

export const FAQS = [
  {
    q: "¿Son relojes originales?",
    a: "Sí. Todos nuestros relojes son originales de las marcas Pagani Design, Wishdoit y Specht & Söhne — reconocidas microbrands de relojería con excelente relación calidad-precio. Cada pieza llega con su empaque, garantía y documentación oficial.",
  },
  {
    q: "¿Qué calidad tienen?",
    a: "Alta calidad garantizada: cajas de acero inoxidable 316L, cristal de zafiro en la mayoría de modelos, movimientos automáticos japoneses Miyota o Seiko NH35, y luminiscencia SuperLuminova. La misma calidad que encuentras en relojes de marcas cinco veces más caras.",
  },
  {
    q: "¿Son resistentes al agua?",
    a: "Sí. Todos nuestros modelos son resistentes al agua. Los modelos diver tienen resistencia de hasta 200m (apta para buceo), los sport hasta 100m (natación) y los dress hasta 50m (uso diario). La resistencia específica se detalla en cada ficha.",
  },
  {
    q: "¿Cuánto tarda el envío?",
    a: "Entre 5 y 12 días hábiles a todo el mundo. Embalaje protegido y con seguimiento incluido.",
  },
  {
    q: "¿Cómo se paga?",
    a: "Coordinamos todo por WhatsApp. Aceptamos transferencia bancaria, PayPal, Wise, USDT y otros métodos locales según tu país.",
  },
  {
    q: "¿Ofrecen garantía?",
    a: "Sí. 12 meses de garantía oficial contra cualquier defecto de fabricación. Si algo falla, lo reparamos o reemplazamos sin coste.",
  },
];
